export const DEBUG = false;
export const CI = false;
